
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { downloadPDF } from "@/utils/pdf.js";
import { downloadExportWord, auditPassed, auditHangs, serverrPDF } from "@/api/credit-note";
@Component({
  name: "ModifyDiscounts",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: false }) private isAnnual: boolean;
  @Prop({ default: "索赔维护" }) private title: "";
  // @Prop({ default: {} }) private selectedItem: {};
  @Prop({ default: {} as any }) private resTouch: any;
  @Prop({ default: {} as any }) private FAitem: any;
  @Prop({ default: false }) private showOtherBtn: boolean;

  @Prop({ default: 'CREDIT_NOTE' }) private tableNoteType: '';

  public resList = [];
  private GuaQiReason = "";
  private dialogVisible = false;

  // public print: {
  //   id: 'adv1',
  //   popTitle: '产装联系单', // 打印配置页上方的标题
  //   extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
  //   preview: false, // 是否启动预览模式，默认是false
  //   previewTitle: '预览的标题', // 打印预览的标题
  //   previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
  //   zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
  //   previewBeforeOpenCallback() {
  //     console.log('正在加载预览窗口！')
  //   }, // 预览窗口打开之前的callback
  //   previewOpenCallback() {
  //     console.log('已经加载完预览窗口，预览打开了！')
  //   }, // 预览窗口打开时的callback
  //   beforeOpenCallback() {
  //     console.log('开始打印之前！')
  //   }, // 开始打印之前的callback
  //   openCallback() {
  //     console.log('执行打印了！')
  //   }, // 调用打印时的callback
  //   closeCallback() {
  //     console.log('关闭了打印工具！')
  //   }, // 关闭打印的callback(无法区分确认or取消)
  //   clickMounted() {
  //     console.log('点击v-print绑定的按钮了！')
  //   },
  //   // url: 'http://localhost:8080/', // 打印指定的URL，确保同源策略相同
  //   // asyncUrl (reslove) {
  //   //   setTimeout(() => {
  //   //     reslove('http://localhost:8080/')
  //   //   }, 2000)
  //   // },
  //   standard: '',
  //   extarCss: '',
  // }

  mounted() {
    this.getAudits();
  }

  private cnCode = "";
  private cnAmount = "";
  private cnType = "";
  private IssBY = "";
  private IssDate = "";
  private ivCompanyName = "";
  private ivAddress = "";
  private nation = "";
  private ivOtherInfo = "";

  private async getAudits() {
    this.resList = this.resTouch.terms;
    this.cnCode = this.resTouch.creditNoteCode;
    this.cnAmount = this.resTouch.creditNoteAmount;
    this.IssBY = this.resTouch.issuedBy;
    this.IssDate = this.resTouch.issuedDate;
    this.cnType = this.resTouch.currency;
    this.ivCompanyName = this.resTouch.ivCompanyName;
    this.ivAddress = this.resTouch.ivAddress;
    this.nation = this.resTouch.nation;
    this.ivOtherInfo = this.resTouch.ivOtherInfo;
  }

  private async handleExport() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    await serverrPDF(this.FAitem.id).then(res => {
      loading.close();
      this.$notify({
        title: "提示",
        message: "下载成功",
        type: "success",
        duration: 2000,
      });
    }).catch(err => {
      loading.close();
      console.log(err);
    })
    // let file_obj = await downloadPDF(
    //   this.$refs.pdf,
    //   {
    //     // scale: window.devicePixelRatio * 4,
    //     allowTaint: true,
    //     useCORS: true,
    //     scrollY: 0,
    //     scrollX: 0,
    //     removeContainer: true,
    //     onclone: true,
    //   },
    //   "CN.pdf"
    // );
    // console.log("file_obj", file_obj);
    // this.downloadBlob(file_obj, `${this.cnCode}模版.pdf`);
    // this.$emit('handleExport1')
  }

  private handleCancel() {
    this.$emit("handleCancel");
  }

  private handleGua() {
    this.dialogVisible = true;
  }

  private async submitGuaQi() {
    if (this.GuaQiReason === "") {
      this.$notify({
        title: "提示",
        message: "请输入挂起原因",
        type: "error",
        duration: 2000,
      });
      return;
    }
    let params = {
      auditHangReason: this.GuaQiReason,
    };
    console.log("FAitem", this.FAitem);
    await auditHangs(this.FAitem.id, params);
    this.dialogVisible = false;
    this.$emit("handleGua");
  }

  private async handlePass() {
    await auditPassed(this.FAitem.id);
    this.$emit("handlePass");
  }

  private downloadBlob(data, fileName) {
    // 1.解析 blob 数据 生成 url
    const blob = new Blob([data]);
    const url = window.URL.createObjectURL(blob);
    // 2.创建下载链接+自动下载
    const link: any = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link);
  }

  private async handleWord() {
    await downloadExportWord(this.FAitem.id).then(res => {
      this.$notify({
        title: "成功",
        message: "下载成功",
        type: "success",
        duration: 2000,
      });
    }).catch(err => {
      console.log(err)
    });
  }

  // @Watch("show", { immediate: true })
  // private async watchData() {

  // }
}
